const NUMBER_LOCALE = "de-AT";
const DECIMAL_FORMATTERS = new Map();

const getDecimalFormatter = (fractionDigits, useGrouping) => {
  const key = `${fractionDigits}:${useGrouping}`;
  if (!DECIMAL_FORMATTERS.has(key)) {
    DECIMAL_FORMATTERS.set(
      key,
      new Intl.NumberFormat(NUMBER_LOCALE, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
        useGrouping,
      })
    );
  }
  return DECIMAL_FORMATTERS.get(key);
};

export const formatDecimal = (value, fractionDigits = 2, useGrouping = false) => {
  const safeValue = Number.isFinite(value) ? value : 0;
  return getDecimalFormatter(fractionDigits, useGrouping).format(safeValue);
};

export { NUMBER_LOCALE };

export default formatDecimal;
